<ion-list *ngIf="model && err" lines="none" style=" padding-bottom: 2rem;
    padding-right: 9px;" class="{{this.design}}">
    <ng-container *ngFor="let field of fields">

<!--        <div *ngIf="showZakelijkFields">-->
            <ion-item *ngIf="field.type == 'addedField'">
                <div class="label-group">
                    <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                    <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
                </div>
                <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
    
                <ion-input [(ngModel)]="model[field.name]" class="ion-input-list">
                    <!--          <div style="position:absolute;right:30px;" ><i style="color:#419bd7;" class="{{field.logoIcon}}"></i></div>-->
                </ion-input>
            </ion-item>

            <ion-item *ngIf="field.type == 'addedMoney'">
                <div class="label-group">
                    <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                    <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
                </div>
                <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
                <app-dutch-currency-field [model]="model" [fieldName]="field.name"></app-dutch-currency-field>

                <!-- <ion-input [(ngModel)]="model[field.name]" class="ion-input-list" (ionBlur)="getFormat(model[field.name], field.label);" (keypress)="numberOnlyValidation($event)"> -->
                    <!--          <div style="position:absolute;right:30px;" ><i style="color:#419bd7;" class="{{field.logoIcon}}"></i></div>-->
                <!-- </ion-input> -->
            </ion-item>

            <ion-item *ngIf="field.type == 'addedDate'">
                <div class="label-group">
                    <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                    <ion-icon name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
                </div>
                <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

                <app-date-picker
                        *ngIf="!isMobile"
                        [maxDate] = "MAX_DATE"
                        [model]="model"
                        [fieldName]="field.name"
                ></app-date-picker>
                <ion-datetime [(ngModel)]="model[field.name]"
                              *ngIf="isMobile"
                              displayFormat="DDDD, D MMM YYYY"
                              monthShortNames="jan, feb, maart, apr, mei, juni, juli, aug, sept, okt, nov, dec"
                              dayShortNames="ma, di, wo, do, vr, za, zo"
                              dayNames="maandag, dinsdag, woensdag, donderdag, vrijdag, zaterdag, zondag"
                              [max]="MAX_DATE" class="ion-input-list" style="position:relative;">
                </ion-datetime>
            </ion-item>
<!--        </div>-->

<!--        <div *ngIf="showLoondienstFields">-->
            <ion-item *ngIf="field.type == 'loonString'">
                <div class="label-group">
                    <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                    <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
                </div>
                <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
    
                <ion-input [(ngModel)]="model[field.name]" class="ion-input-list">
                    <!--          <div style="position:absolute;right:30px;" ><i style="color:#419bd7;" class="{{field.logoIcon}}"></i></div>-->
                </ion-input>
    
            </ion-item>

            <ion-item *ngIf="field.type == 'loonMoney'">
                <div class="label-group">
                    <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                    <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
                </div>
                <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
                <app-dutch-currency-field [model]="model" [fieldName]="field.name"></app-dutch-currency-field>

                <!-- <ion-input [(ngModel)]="model[field.name]" class="ion-input-list" (ionBlur)="getFormat(model[field.name], field.label);" (keypress)="numberOnlyValidation($event)"> -->
                    <!--          <div style="position:absolute;right:30px;" ><i style="color:#419bd7;" class="{{field.logoIcon}}"></i></div>-->
                <!-- </ion-input> -->
            </ion-item>

            <ion-item *ngIf="field.type == 'loonDate'">
                <div class="label-group">
                    <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                    <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
                </div>
                <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

                <app-date-picker
                        *ngIf="!isMobile"
                        [maxDate] = "MAX_DATE"
                        [model]="model"
                        [fieldName]="field.name"
                ></app-date-picker>
                <ion-datetime [(ngModel)]="model[field.name]"
                              *ngIf="isMobile"
                              displayFormat="DDDD, D MMM YYYY"
                              monthShortNames="jan, feb, maart, apr, mei, juni, juli, aug, sept, okt, nov, dec"
                              dayShortNames="ma, di, wo, do, vr, za, zo"
                              dayNames="maandag, dinsdag, woensdag, donderdag, vrijdag, zaterdag, zondag"
                              [max]="MAX_DATE" class="ion-input-list" style="position:relative;">
                </ion-datetime>
            </ion-item>

            <ion-item *ngIf="field.type == 'loonBool'">
                <div class="label-group">
                    <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                    <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
                </div>
                <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
                <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                    <ion-select-option [value]="false">Nee</ion-select-option>
                    <ion-select-option [value]="true">Ja</ion-select-option>
                </ion-select>
<!--                <div style="position:absolute;margin-top:38px;right:35px;"><i style="color:#419bd7;"-->
<!--                                                                              class="{{field.logoIcon}}"></i></div>-->
                <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
            </ion-item>

            <ion-item *ngIf="field.type == 'loonContract'">
                <div class="label-group">
                    <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                    <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
                </div>
                <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
    
                <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                    <ion-select-option *ngFor="let contract of contracts$ | async" [value]="contract.id">
                        {{contract['name']}}
                    </ion-select-option>
                </ion-select>
                <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
            </ion-item>

            <ion-item *ngIf="field.type == 'dertiende'">
                <div class="label-group">
                    <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                    <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
                </div>
                <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
    
                <ion-input class="ion-input-list" value='8,33 %' [readonly]="true" >

                </ion-input>

            </ion-item>

            <ion-item *ngIf="field.type == 'vakantiegeld'">
                <div class="label-group">
                    <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                    <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
                </div>
                <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
    
                <ion-input class="ion-input-list" value='8 %' [readonly]="true" >

                </ion-input>

            </ion-item>
<!--        </div>-->

        <ion-item *ngIf="field.type == 'string'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-input [(ngModel)]="model[field.name]" class="ion-input-list">
                <!--          <div style="position:absolute;right:30px;" ><i style="color:#419bd7;" class="{{field.logoIcon}}"></i></div>-->
            </ion-input>

        </ion-item>

        <ion-item *ngIf="field.type == 'text'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-textarea [(ngModel)]="model[field.name]" class="ion-input-list">
                <!--        <div style="position:absolute;right:30px;" ><i style="color:#419bd7;" class="{{field.logoIcon}}"></i></div>-->
            </ion-textarea>
        </ion-item>

        <ion-item *ngIf="field.type == 'date'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <app-date-picker
                    *ngIf="!isMobile"
                    [maxDate] = "MAX_DATE"
                    [model]="model"
                    [fieldName]="field.name"
            ></app-date-picker>
            <ion-datetime [(ngModel)]="model[field.name]"
                          *ngIf="isMobile"
                          displayFormat="DDDD, D MMM YYYY"
                          monthShortNames="jan, feb, maart, apr, mei, juni, juli, aug, sept, okt, nov, dec"
                          dayShortNames="ma, di, wo, do, vr, za, zo"
                          dayNames="maandag, dinsdag, woensdag, donderdag, vrijdag, zaterdag, zondag"
                          [max]="MAX_DATE" class="ion-input-list" style="position:relative;">
            </ion-datetime>
        </ion-item>

        <ion-item *ngIf="field.type == 'gender'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                <ion-select-option value="MALE">Man</ion-select-option>
                <ion-select-option value="FEMALE">Vrouw</ion-select-option>
            </ion-select>
<!--            <div style="position:absolute;margin-top:64px;right:33px;"><i-->
<!--                    style="color:#419bd7;font-size: 20px;font-weight: Bold;" class="fas fa-chevron-down"></i></div>-->
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <div *ngIf="showDropdownField">
            <ion-item *ngIf="field.type == 'number'">
                <div class="label-group">
                    <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                    <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
                </div>
                <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
    
                <ion-input inputmode="tel" pattern="tel" type="number" [(ngModel)]="model[field.name]" class="ion-input-list">
                    <div class="icon-container"><i class="icon-right {{field.logoIcon}}"></i></div>
                </ion-input>
            </ion-item>
        </div>

        <ion-item *ngIf="field.type == 'number'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-input inputmode="tel" pattern="tel" type="number" [(ngModel)]="model[field.name]" class="ion-input-list">
                <div class="icon-container"><i class="icon-right {{field.logoIcon}}"></i></div>
            </ion-input>
        </ion-item>

        <ion-item *ngIf="field.type == 'm2'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-input inputmode="tel" pattern="tel" type="m2" [(ngModel)]="model[field.name]" class="ion-input-list">
                <div style="position:absolute;right:22px;"><p
                        style="color:#419bd7;font-size: 20px;font-weight: 700;font-family: Roboto;">m2</p></div>
            </ion-input>
        </ion-item>

        <ion-item *ngIf="field.type == 'm3'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-input inputmode="tel" pattern="tel" type="m3" [(ngModel)]="model[field.name]" class="ion-input-list">
                <div style="position:absolute;right:22px;"><p
                        style="color:#419bd7;font-size: 20px;font-weight: 700;font-family: Roboto;">m3</p></div>
            </ion-input>
        </ion-item>

        <ion-item *ngIf="field.type == 'money'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
            <app-dutch-currency-field [model]="model" [fieldName]="field.name"></app-dutch-currency-field>
            <!-- <ion-input type="text" [(ngModel)]="model[field.name]" class="ion-input-list" (ionBlur)="getFormat(model[field.name], field.label);" (keypress)="numberOnlyValidation($event)" >
                <div class="icon-container"><i style="color:#419bd7;font-size: 20px;font-weight: 800;"
                                               class="fas fa-euro-sign"></i></div>
            </ion-input> -->
        </ion-item>

        <ion-item *ngIf="field.type == 'phone'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-input type="tel" [(ngModel)]="model[field.name]" class="ion-input-list">
                <div style="position:absolute;right:30px;"><i style="color:#419bd7;" class="{{field.logoIcon}}"></i>
                </div>
            </ion-input>
        </ion-item>

        <ion-item *ngIf="field.type == 'email'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-input type="email" [(ngModel)]="model[field.name]" class="ion-input-list">
                <div style="position:absolute;right:30px;"><i style="color:#419bd7;" class="{{field.logoIcon}}"></i>
                </div>
            </ion-input>
        </ion-item>

        <ion-item *ngIf="field.type == 'boolean'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                <ion-select-option [value]="0">Nee</ion-select-option>
                <ion-select-option [value]="1">Ja</ion-select-option>
            </ion-select>
<!--            <div style="position:absolute;margin-top:65px;right:35px;"><i style="color:#419bd7;"-->
<!--                                                                          class="{{field.logoIcon}}"></i></div>-->
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <!-- Use boolean above if found out why using type=boolean is generating integer instead of boolean -->
        <ion-item *ngIf="field.type == 'boolean_data'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                <ion-select-option [value]="false">Nee</ion-select-option>
                <ion-select-option [value]="true">Ja</ion-select-option>
            </ion-select>
<!--            <div style="position:absolute;margin-top:65px;right:35px;"><i style="color:#419bd7;"-->
<!--                                                                          class="{{field.logoIcon}}"></i></div>-->
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <!-- RELATIONCONFIGS -->

        <ion-item *ngIf="field.type == 'nationality' || field.type == 'country'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                <ion-select-option *ngFor="let country of countries$ | async" [value]="country.id">
                    {{country.name}}
                </ion-select-option>
            </ion-select>
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <ion-item *ngIf="field.type == 'relation'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                <ion-select-option *ngFor="let relation of relations$ | async" [value]="relation.id">
                    {{relation.name}}
                </ion-select-option>
            </ion-select>
<!--            <div style="position:absolute;margin-top:64px;right:33px;"><i-->
<!--                    style="color:#419bd7;font-size: 20px;font-weight: Bold;" class="fas fa-chevron-down"></i></div>-->
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>
        
        <ion-item *ngIf="field.type == 'vehicle_type'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list">
                <ion-select-option *ngFor="let relation of vehicleTypes$ | async" [value]="relation.id">
                    {{relation.name}}
                </ion-select-option>
            </ion-select>

            <ion-icon name="airplane-outline" slot="end"></ion-icon>
        </ion-item>

        <ion-item *ngIf="field.type == 'cancellation_period'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list">
                <ion-select-option *ngFor="let relation of cancellationPeriods$ | async" [value]="relation.id">
                    {{relation.name}}
                </ion-select-option>
            </ion-select>
<!--            <div style="position:absolute;margin-top:65px;right:35px;"><i style="color:#419bd7;"-->
<!--                                                                          class="{{field.logoIcon}}"></i></div>-->
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <ion-item *ngIf="field.type == 'person'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list">
                <ion-select-option *ngFor="let person of people$ | async" [value]="person.id">
                    {{format.formatPersonName(person)}}
                </ion-select-option>
            </ion-select>
<!--            <div style="position:absolute;margin-top:65px;right:35px;"><i style="color:#419bd7;"-->
<!--                                                                          class="{{field.logoIcon}}"></i></div>-->
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <ion-item *ngIf="field.type == 'contract'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                <ion-select-option *ngFor="let contract of contracts$ | async" [value]="contract.id">
                    {{contract['name']}}
                </ion-select-option>
            </ion-select>
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <ion-item *ngIf="field.type == 'address'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list">
                <ion-select-option *ngFor="let address of addresses$ | async" [value]="address.id">
                    {{address['name']}}
                </ion-select-option>
            </ion-select>
<!--            <div style="position:absolute;margin-top:65px;right:35px;"><i style="color:#419bd7;"-->
<!--                                                                          class="{{field.logoIcon}}"></i></div>-->
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <ion-item *ngIf="field.type == 'retirement_type'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list">
                <ion-select-option *ngFor="let relation of retirementTypes$ | async" [value]="relation.id">
                    {{relation['name']}}
                </ion-select-option>
            </ion-select>
<!--            <div style="position:absolute;margin-top:65px;right:35px;"><i style="color:#419bd7;"-->
<!--                                                                          class="{{field.logoIcon}}"></i></div>-->
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <ion-item *ngIf="field.type == 'financial_companies'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                <ion-select-option *ngFor="let financialCompany of this.financialCompanies$ | async"
                                   [value]="financialCompany.id">
                    {{financialCompany['name']}}
                </ion-select-option>
            </ion-select>
<!--            <div style="position:absolute;margin-top:64px;right:33px;"><i-->
<!--                    style="color:#419bd7;font-size: 20px;font-weight: Bold;" class="fas fa-chevron-down"></i></div>-->
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <ion-item *ngIf="field.type == 'home_types'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                <ion-select-option *ngFor="let relation of homeTypesQuery.selectAll() | async" [value]="relation.id">
                    {{relation['name']}}
                </ion-select-option>
            </ion-select>
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <ion-item *ngIf="field.type == 'mortgage_types'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                <ion-select-option *ngFor="let relation of mortgageTypesQuery.selectAll() | async"
                                   [value]="relation.id">
                    {{relation['name']}}
                </ion-select-option>
            </ion-select>
<!--            <div style="position:absolute;margin-top:64px;right:33px;"><i-->
<!--                    style="color:#419bd7;font-size: 20px;font-weight: 800;" class="fas fa-chevron-down"></i></div>-->
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <ion-item *ngIf="field.type == 'marital_status_config'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
            <ion-select [(ngModel)]="model[field.name]" (ionChange)="maritalChange(model[field.name]);" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                <ion-select-option
                        *ngFor="let marital_status of popularAppStatesService.getQuery(field.data).selectAll() | async"
                        [value]="marital_status.id">
                    {{ marital_status['name'] }}
                </ion-select-option>
            </ion-select>
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <ion-item *ngIf="field.type == 'relation_config'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                <ion-select-option
                        *ngFor="let relation of popularAppStatesService.getQuery(field.data).selectAll() | async"
                        [value]="relation.id">
                    {{relation['name']}}
                </ion-select-option>
            </ion-select>
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <!-- Added by Joseph (Education Field) -->
        <ion-item *ngIf="field.type == 'education_config'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>
            <ion-select [(ngModel)]="model[field.name]" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                <ion-select-option *ngFor="let education of educations$ | async" [value]="education.id">
                    {{education.name}}
                </ion-select-option>
            </ion-select>
<!--            <div style="position:absolute;margin-top:64px;right:33px;"><i-->
<!--                    style="color:#419bd7;font-size: 20px;font-weight: Bold;" class="fas fa-chevron-down"></i></div>-->
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <ion-item *ngIf="field.type == 'dropdown'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" (ionChange)="dropdownChange(model[field.name]);" placeholder="Selecteer" class="ion-input-list" appNoArrow>
                <ion-select-option *ngFor="let content of field.data.contents" [value]="content.value">
                    {{content.key}}
                </ion-select-option>
            </ion-select>
<!--            <div style="position:absolute;margin-top:64px;right:33px;"><i-->
<!--                    style="color:#419bd7;font-size: 2px;font-weight: 800;" class="fas fa-chevron-down"></i></div>-->
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <!-- Life Insurance Dropdown option -->
        <ion-item *ngIf="field.type == 'life_insurances_type'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" placeholder="Insured amount (p/m cost)" class="ion-input-list"
                        appNoArrow>
                <ion-select-option *ngFor="let life_insurance of lifeInsurance$ | async" [value]="life_insurance.id">
                    {{life_insurance.type + ', ' + life_insurance.insured_amount + ' (p/m cost)'}}
                </ion-select-option>
            </ion-select>
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <!-- HOMES -->
        <ion-item *ngIf="field.type == 'homes'">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <ion-select [(ngModel)]="model[field.name]" class="ion-input-list"
                        placeholder="Selecteer"
                        appNoArrow>
                <ion-select-option *ngFor="let home of homes$ | async" [value]="home.id">
                    <ng-container *ngIf="home && home.address">
                        {{home.address.address}} {{home.address.city}}, {{home.address.country.name}}
                    </ng-container>
                </ion-select-option>
            </ion-select>
            <div class="icon-container"><i class="icon-right fas fa-chevron-down"></i></div>
        </ion-item>

        <!-- HASONE -->
        <ion-item *ngIf="field.type == 'hasone' && model[field.name]">
            <div class="label-group">
                <ion-label class="ion-text" position="stacked">{{field.label}}</ion-label>
                <ion-icon *ngIf="foundTooltip(field)" name="help-circle-outline" (click)="showHelpInfo(field)" class="help-icon"></ion-icon>
            </div>
            <app-form-error [errors]="err.getErrors(field.name)"></app-form-error>

            <app-crudbuilder class="subcrud" [config]="field.data['config']" [model]="model[field.name]"
                             [err]="err">
            </app-crudbuilder>
        </ion-item>

    </ng-container>
</ion-list>
